import CustomerSearchValue from "../../../domain/customer/criteria/CustomerSearchValue";
import CustomerSortType    from "../../../domain/customer/criteria/CustomerSortType";
import Customers           from "../../../domain/customer/Customers";
import CurrentPage         from "../../../domain/fundamentals/pagination/CurrentPage";
import ResKaReduxAction    from "../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_CUSTOMERS = "SET_CUSTOMERS",
  SET_CUSTOMERS_CURRENT_PAGE = "SET_CUSTOMERS_CURRENT_PAGE",
  SET_CUSTOMERS_SEARCH_VALUE = "SET_CUSTOMERS_SEARCH_VALUE",
  SET_CUSTOMERS_SORT_TYPE = "SET_CUSTOMERS_SORT_TYPE"
}

export interface SetCustomersAction extends ResKaReduxAction {
  customers: Customers;
}

export interface SetCustomersCurrentPageAction extends ResKaReduxAction {
  currentPage: CurrentPage;
}

export interface SetCustomersSearchValueAction extends ResKaReduxAction {
  search: CustomerSearchValue;
}

export interface SetCustomersSortTypeAction extends ResKaReduxAction {
  sortType: CustomerSortType;
}

export type CustomersAction =
  SetCustomersAction
  | SetCustomersCurrentPageAction
  | SetCustomersSearchValueAction
  | SetCustomersSortTypeAction
  ;

export const setCustomersAction = (customers: Customers): SetCustomersAction => ({
  type: ACTION_TYPE.SET_CUSTOMERS,
  customers: customers,
});

export const setCustomersCurrentPageAction = (currentPage: CurrentPage): SetCustomersCurrentPageAction => ({
  type: ACTION_TYPE.SET_CUSTOMERS_CURRENT_PAGE,
  currentPage: currentPage,
});

export const setCustomersSearchValueAction = (search: CustomerSearchValue): SetCustomersSearchValueAction => ({
  type: ACTION_TYPE.SET_CUSTOMERS_SEARCH_VALUE,
  search: search,
});

export const setCustomersSortTypeAction = (sortType: CustomerSortType): SetCustomersSortTypeAction => ({
  type: ACTION_TYPE.SET_CUSTOMERS_SORT_TYPE,
  sortType: sortType,
});